
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[level_zero]/interest-form",
      function () {
        return require("private-next-pages/[level_zero]/interest-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[level_zero]/interest-form"])
      });
    }
  